var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',[_vm._v(" You will be logged out and logged in as "),_c('strong',[_vm._v(_vm._s(_vm.editingItem.UserName))])]),_c('SaveButton',{attrs:{"label":"Login as this user","action-label":"Logging in","saving":_vm.processing},on:{"click":function($event){return _vm.action()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }